const mutations = {
    setMyCompanyMocker(state,payload){
        state.me.company = payload
    },
    setMe(state,payload){
        let user =  checkUserRole(payload)
        user =  _.pick(user,['customClaims','uid','email','displayName', 'companyId'])
        state.me =user
    },
  setMeRights(state,payload){
     state.me.rights = payload
  },
    setUsers(state,payload) {
        state.users = payload
    }
}

export default mutations



function checkUserRole(user) {
    if(!user) {
        return user;
    }

    if(user.type === "user"){
        user.user = true
    }
    if(user.type === "admin"){
        user.user = true, user.admin = true
    }
    if(user.type === "root"){
        user.user = true, user.admin = true, user.root = true
    }

    return user
}